(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["flags-parallax-hero"] && !Shopify.designMode) return;
  try {
    
(function() {
  function initFlagsHero(section) {
    if (!section || section.dataset.tfhInit) return;
    section.dataset.tfhInit = '1';

    var layers = section.querySelectorAll('[data-tfh-layer]');
    if (!layers.length) return;

    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var raf = null;
    function update() {
      raf = null;
      var r = section.getBoundingClientRect();
      var vh = window.innerHeight;
      var total = r.height + vh;
      var passed = vh - r.top;
      var p = Math.max(0, Math.min(1, passed / total));
      var t = p - 0.5;
      for (var i = 0; i < layers.length; i++) {
        var rate = parseFloat(layers[i].getAttribute('data-rate')) || 0;
        layers[i].style.transform = 'translate3d(0,' + (t * rate * 400).toFixed(2) + 'px,0)';
      }
    }
    function onScroll() {
      if (!raf) raf = requestAnimationFrame(update);
    }

    update();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);

    document.addEventListener('shopify:section:unload', function(e) {
      if (e.target === section) {
        window.removeEventListener('scroll', onScroll);
        window.removeEventListener('resize', onScroll);
      }
    });
  }

  function initAll() {
    document.querySelectorAll('[data-section-type="flags-parallax-hero"]').forEach(initFlagsHero);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function(e) {
    var sec = e.target.querySelector('[data-section-type="flags-parallax-hero"]');
    if (sec) initFlagsHero(sec);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
